import React, { FC, useCallback, useEffect, useState } from 'react';
import { SwitchTransition } from 'react-transition-group';
import styled from 'styled-components';
import { getWindow } from '../../utils/getWindow';
import { ymTrackClickToInstall } from '../../utils/metrika';
import { useTranslation } from '../../utils/useTranslation';
import { IconClose } from '../icon/IconClose';
import { IconLogo } from '../icon/IconLogo';
import { Box } from '../layout/Box';
import { Flex } from '../layout/Flex';
import { makeTransitionComponent } from '../transition/makeTransitionComponent';
import { Typography } from '../typography/Typography';

export const APP_DOWNLOAD_LINK = 'https://clck.ru/3CBSWm';

const TransitionSlideUp = makeTransitionComponent((timeout) => ({
    default: {
        opacity: 0,
        transform: 'translateY(100%) translateX(-50%)',
        transitionDelay: '0ms',
        transitionDuration: `${timeout}ms`,
        transitionTimingFunction: 'cubic-bezier(0, 0, 0.2, 1)',
        transitionProperty: 'transform, opacity',
    },
    entering: { transform: 'translateY(100%) translateX(-50%)', opacity: 0 },
    entered: { transform: 'translateY(0) translateX(-50%)', opacity: 1 },
}));

export const Container = styled(Box).withConfig({ displayName: 'Container' }).attrs({
    position: 'fixed',
    bottom: 'calc(3vw + 54px)',
    left: '50%',
    width: '96vw',
    borderRadius: '16px',
    padding: 1,
    overflow: 'hidden',
    zIndex: 10,
    backgroundColor: 'var(--color-invert-blur)',
    backdropFilter: 'blur(25px)',
})``;

interface AppDiscoveryMobileProps {
    onClose: () => void;
    timeout: number;
}

enum AppDiscoveryDescStep {
    CLOSE = 'close',
    OPEN = 'open',
}

export const AppDiscoveryMobile: FC<AppDiscoveryMobileProps> = ({ onClose, timeout }) => {
    const [step, setStep] = useState<AppDiscoveryDescStep>(AppDiscoveryDescStep.CLOSE);
    const t = useTranslation();

    const onDownloadClick = () => {
        ymTrackClickToInstall();
        window.open(APP_DOWNLOAD_LINK, '_blank');
    };

    const onCloseClick = useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation();
            setStep(AppDiscoveryDescStep.CLOSE);
            onClose();
        },
        [onClose],
    );

    useEffect(() => {
        getWindow()?.setTimeout(() => {
            setStep(AppDiscoveryDescStep.OPEN);
        });
    }, []);

    return (
        <SwitchTransition>
            <TransitionSlideUp key={step} timeout={timeout}>
                <Container>
                    <Flex
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        onClick={onDownloadClick}
                    >
                        <Flex direction="row" alignItems="center">
                            <Box>
                                <IconLogo fontSize={40} />
                            </Box>
                            <Box ml={1}>
                                <Typography
                                    color="var(--color-primary)"
                                    weight="bold"
                                    variant="body2"
                                >
                                    {t('Перейти в приложение')}
                                </Typography>
                                <Typography
                                    color="var(--color-primary)"
                                    weight="regular"
                                    variant="caption"
                                >
                                    {t('Чтобы получить все возможности')}
                                </Typography>
                            </Box>
                        </Flex>
                        <IconClose
                            fontSize={24}
                            color="var(--color-primary)"
                            onClick={onCloseClick}
                        />
                    </Flex>
                </Container>
            </TransitionSlideUp>
        </SwitchTransition>
    );
};
